import axios from "axios";
export default {
  data() {
    return {
      weburl: "https://www.rayscloud.cn/webapi",
      defaultImg: require("../../assets/resource/news-1.jpg"),
      siteId: 0,
      menuId: 0,
      childId: 0,
      childIds: 0,
      menu: {},
      navList: [],
      newList: [],
      current: 83
    };
  },
  methods: {
    setmenuId(serId) {
      this.childIds = serId;
      this.current = serId;
      // console.log(this.current);
      let menu = this.navList.find(x => x.serId == serId);
      localStorage.setItem("secondMenu", JSON.stringify(menu));
      this.getContent();
    },
    toContant(code, linkUrl) {
      if (linkUrl) {
        var link = linkUrl;
        if (link.includes("https://www.rayscloud.cn")) {
          this.$router.push(link.replace("https://www.rayscloud.cn", ""));
        } else {
          window.open(link, "_blank");
        }
      } else {
        let route = this.$router.resolve({
          path: `/productContent?code=${code}`
        });
        window.open(route.href, "_blank");
      }
    },
    getchild() {
      axios
        .get(`${this.weburl}/api/Site/Menu/${this.siteId}/${this.childId}`)
        .then(res => {
          if (res.status == 200) {
            this.navList = res.data.data;
            if (this.navList.length > 0) {
              this.childIds = this.navList[0].serId;
              this.getContent();
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getContent() {
      let searchstr = {
        page: 1,
        pageSize: 999,
        siteId: this.siteId,
        menu: this.menuId,
        child: this.childId,
        childs: this.childIds,
        form: "font"
      };
      axios
        .post(`${this.weburl}/api/Cont/list`, searchstr)
        .then(res => {
          if (res.status == 200) {
            this.newList = res.data.data.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  created() {
    let query = this.$route.query;
    this.siteId = query.siteId ? query.siteId : localStorage.getItem("siteId");
    this.menuId = query.menuId ? query.menuId : localStorage.getItem("menuId");
    this.childId = query.childId
      ? query.childId
      : localStorage.getItem("childId");
    this.getchild();
  }
};
